document.addEventListener("DOMContentLoaded", () => {
  const modal = document.querySelector("[data-zoom-modal]");
  if (!modal) return;

  const imgEl = modal.querySelector("[data-zoom-img]");
  const thumbsContainer = modal.querySelector("[data-zoom-thumbs-container]");
  const prevBtn = modal.querySelector("[data-zoom-prev]");
  const nextBtn = modal.querySelector("[data-zoom-next]");
  const mainView = modal.querySelector(".zoom-modal__main-view") || modal.querySelector(".zoom-modal__container");

  let imageList = [];
  let currentIndex = 0;
  let isZoomed = false;

  const renderThumbnails = () => {
    if (!thumbsContainer) return;
    thumbsContainer.innerHTML = "";

    imageList.forEach((url, idx) => {
      const thumbBtn = document.createElement("button");
      thumbBtn.type = "button";
      thumbBtn.className = `zoom-thumb-card ${idx === currentIndex ? "is-active" : ""}`;
      thumbBtn.setAttribute("aria-label", `View image ${idx + 1}`);

      const thumbImg = document.createElement("img");
      thumbImg.src = url;
      thumbImg.alt = `Thumbnail ${idx + 1}`;

      thumbBtn.appendChild(thumbImg);
      thumbBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        updateZoomImage(idx);
      });

      thumbsContainer.appendChild(thumbBtn);
    });
  };

  const updateZoomImage = (index) => {
    if (imageList.length === 0) return;
    if (index < 0) index = imageList.length - 1;
    if (index >= imageList.length) index = 0;
    currentIndex = index;

    if (imgEl && imageList[currentIndex]) {
      imgEl.src = imageList[currentIndex];
      imgEl.style.transform = "none";
      imgEl.style.cursor = "zoom-in";
      isZoomed = false;
    }

    if (thumbsContainer) {
      const thumbs = thumbsContainer.querySelectorAll(".zoom-thumb-card");
      thumbs.forEach((t, i) => {
        if (i === currentIndex) {
          t.classList.add("is-active");
          t.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
        } else {
          t.classList.remove("is-active");
        }
      });
    }
  };

  const openZoom = (urls, index = 0) => {
    imageList = urls;
    renderThumbnails();
    updateZoomImage(index);
    modal.classList.add("is-active");
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("zoom-modal-open");
    document.body.classList.add("zoom-modal-open");
  };

  const closeZoom = () => {
    modal.classList.remove("is-active");
    modal.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("zoom-modal-open");
    document.body.classList.remove("zoom-modal-open");
  };

  const getProductImageUrls = () => {
    const urls = [];
    document.querySelectorAll("[data-gallery-slide] img, [data-grid-image] img, .aplus-image-grid img, .product-viewer img").forEach(img => {
      const src = img.getAttribute("src") || img.currentSrc;
      if (src) {
        const highResSrc = src.replace(/width=\d+/, "width=1800");
        if (!urls.includes(highResSrc)) urls.push(highResSrc);
      }
    });
    return urls;
  };

  document.addEventListener("click", (e) => {
    // If modal is open, check if user clicked outside image/controls to close
    if (modal.classList.contains("is-active")) {
      const isImg = e.target.closest(".zoom-modal__img");
      const isNav = e.target.closest(".zoom-modal__nav");
      const isThumb = e.target.closest(".zoom-thumb-card");
      const isModalContent = e.target.closest(".image-zoom-modal");

      if (isModalContent && !isImg && !isNav && !isThumb) {
        closeZoom();
        return;
      }
    }

    // Trigger opening zoom when clicking product gallery/aplus images
    const slide = e.target.closest("[data-gallery-slide] img, [data-grid-image] img, .aplus-image-grid img, .product-viewer img");
    if (slide && !e.target.closest(".zoom-modal__container")) {
      e.preventDefault();
      const urls = getProductImageUrls();
      const clickSrc = (slide.getAttribute("src") || slide.currentSrc).replace(/width=\d+/, "width=1800");
      let foundIdx = urls.findIndex(u => u === clickSrc);
      if (foundIdx === -1) foundIdx = 0;
      openZoom(urls, foundIdx);
    }
  });

  if (prevBtn) {
    prevBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      updateZoomImage(currentIndex - 1);
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      updateZoomImage(currentIndex + 1);
    });
  }

  // Touch Swipe Gesture Support
  let touchStartX = 0;
  let touchStartY = 0;
  let touchEndX = 0;
  let touchEndY = 0;

  if (mainView) {
    mainView.addEventListener("touchstart", (e) => {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });

    mainView.addEventListener("touchend", (e) => {
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;
      
      const diffX = touchEndX - touchStartX;
      const diffY = touchEndY - touchStartY;

      if (!isZoomed && Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 35) {
        if (diffX < 0) {
          updateZoomImage(currentIndex + 1);
        } else {
          updateZoomImage(currentIndex - 1);
        }
      }
    }, { passive: true });
  }

  if (imgEl) {
    imgEl.addEventListener("click", (e) => {
      e.stopPropagation();
      isZoomed = !isZoomed;
      imgEl.style.transform = isZoomed ? "scale(2.2)" : "none";
      imgEl.style.cursor = isZoomed ? "zoom-out" : "zoom-in";
    });
  }

  document.addEventListener("keydown", (e) => {
    if (!modal.classList.contains("is-active")) return;
    if (e.key === "Escape") closeZoom();
    if (e.key === "ArrowLeft") updateZoomImage(currentIndex - 1);
    if (e.key === "ArrowRight") updateZoomImage(currentIndex + 1);
  });
});